import axios from '@/plugins/axios';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  rents: {
    list: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 100,
  },
  autoLastState: {},
  lastStateType: null,
};

const actions = {
  async fetchMechanicRents({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('cars/states', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const { cars } = data.data;

      commit('setRents', {
        ...cars,
        list: enumerateArray(cars.items, cars.currentPage, cars.perPage),
      });

      return data;
    } catch (error) {
      return error;
    }
  },

  async fetchLastState({ commit }, carId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get(`cars/${carId}/state/last`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const lastState = data.data.state;

      commit('setLastStateType', data.data.type);
      commit('setAutoLastState', {
        photo: lastState.photo || {},
        mediaComment: lastState.mediaComment || {},
        additionalPhoto: lastState.additionalPhoto || [],
        additionalVideo: lastState.additionalVideo || [],
        additionalPhotoComment: lastState.additionalPhotoComment || {},
        additionalVideoComment: lastState.additionalVideoComment || {},
        equipment: lastState.equipment || {},
        checkList: lastState.checkList || {},
        checkListComment: lastState.checkListComment || {},
      });
      return data;
    } catch (error) {
      return error;
    }
  },

  async acceptCar(_, { carId, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post(`cars/${carId}/state/accept`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch (error) {
      return { error: true };
    }
  },

  async passCar(_, { carId, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post(`cars/${carId}/state/pass `, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },
};

const mutations = {
  setAutoLastState(state, payload) {
    state.autoLastState = payload;
  },

  setLastStateType(state, payload) {
    state.lastStateType = payload;
  },

  // eslint-disable-next-line
  setRents(state, { list, currentPage, lastPage, perPage }) {
    state.rents = {
      list,
      currentPage,
      lastPage,
      perPage,
    };
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
